import { Dispatch } from './type';
import { RequestAction, RequestFailure } from '@Repository/RequestAction';
import type { PayloadAction } from '@reduxjs/toolkit';

export abstract class ILoadingEntityAction {
  protected abstract haveError(message: string): PayloadAction<string>;

  protected abstract areLoading(bool: boolean): PayloadAction<boolean>;

  protected handleFailure(
    response: RequestAction,
    dispatch: Dispatch,
  ): boolean {
    if (response instanceof RequestFailure) {
      const failure = response as RequestFailure;

      dispatch(this.haveError(failure.error.message));
      dispatch(this.areLoading(false));
      return true;
    }

    return false;
  }
}
